import React from 'react';
export var Letter = function Letter() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 70 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7047 73.4019C29.6542 76.8649 22.4858 75.47 16.9797 71.0118C11.4248 66.5143 7.48503 58.842 4.0724 49.5713C-2.65013 31.3091 8.11894 10.8425 28.2479 3.90687C38.2889 0.447119 46.1818 1.89846 52.4116 6.44753C58.6733 11.0198 63.316 18.7663 66.7181 28.0082C73.4201 46.2149 59.8988 66.4438 39.7047 73.4019Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15.8757",
    y: "14.5776",
    width: "37.1633",
    height: "46.2092",
    rx: "1.25",
    fill: "white",
    stroke: "#143F3D",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "23.9213",
    x2: "32.5184",
    y2: "23.9213",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "51.2046",
    x2: "32.5184",
    y2: "51.2046",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "29.9696",
    x2: "47.1955",
    y2: "29.9696",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "34.9696",
    x2: "47.1955",
    y2: "34.9696",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "39.9696",
    x2: "47.1955",
    y2: "39.9696",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.3503",
    y1: "44.9696",
    x2: "47.1955",
    y2: "44.9696",
    stroke: "#143F3D",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75195 13.6808C4.75195 13.6808 7.52307 14.5383 8.84427 14.558",
    stroke: "#43EE91",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8831 5.63782C11.5301 6.6201 12.1772 7.60239 12.8242 8.58468",
    stroke: "#43EE91",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 8.29798C19.5726 7.23156 20.4034 6.18536 21.1479 5.0724",
    stroke: "#43EE91",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 50.3864 67.7354)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 50.3864 67.7354)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 50.3864 67.7354)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 58.8132 60.4336)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 58.8132 60.4336)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 58.8132 60.4336)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 57.4255 68.421)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 57.4255 68.421)",
    fill: "#43EE91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "1.70943",
    ry: "1.71965",
    transform: "matrix(0.182986 -0.983116 0.986642 0.162906 57.4255 68.421)",
    fill: "#43EE91"
  }));
};